import { render, staticRenderFns } from "./my-image.vue?vue&type=template&id=28069f80&scoped=true&"
import script from "./my-image.vue?vue&type=script&lang=js&"
export * from "./my-image.vue?vue&type=script&lang=js&"
import style0 from "./my-image.vue?vue&type=style&index=0&id=28069f80&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28069f80",
  null
  
)

export default component.exports